module.exports = __webpack_public_path__ + "img/emoji_09.c9d3c1a8.png";